import React from 'react'
import {
    Alert,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material'
import {useFieldArray, UseFormReturn} from 'react-hook-form'

import {FormOperacionLCTC} from '../types/types'
import {OperacionLCTCFields} from '../types/fields'
import CardActions from 'src/pages/sistema/components/CardActions'
import { OperacionLCTCFilaCuenta } from './OperacionLCTCFilaCuenta'

interface SeccionNuevoLCTCCuentasProps {
    formMethods: UseFormReturn<FormOperacionLCTC>
}

export const SeccionNuevoLCTCCuentas = ({formMethods}: SeccionNuevoLCTCCuentasProps) => {
    const {fields, append, remove} = useFieldArray({
        control: formMethods.control,
        name: OperacionLCTCFields.Cuentas
    });

    return (
        <CardActions title={'Cuentas'} icon='mdi:account-cash-outline' colapsable>
            {fields.length === 0 ? (
                <Alert severity='info'>Seleccione una Unidad de Negocio para ver las cuentas.</Alert>
            ) : (
                <TableContainer component={Paper}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><Typography variant="body2">Tipo Cliente</Typography></TableCell>
                                <TableCell><Typography variant="body2">Sub-tipo</Typography></TableCell>
                                <TableCell><Typography variant="body2">Límite de concertación (% del AUM)</Typography></TableCell>
                                {/* <TableCell><Typography variant="body2">Límite de liquidación DVP</Typography></TableCell>
                                <TableCell><Typography variant="body2">Límite de liquidación FOP</Typography></TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fields.map((field, index) => (
                                <OperacionLCTCFilaCuenta key={field.id} formMethods={formMethods} index={index}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </CardActions>
    )
}